import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import Logo from "@/components/Logo";
import { toast } from "sonner";
import { UserPlus } from "lucide-react";

export default function Registro() {
  const [form, setForm] = useState({ full_name: "", email: "", password: "" });
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const { data } = await api.post("/auth/register", form);
      setDone(true);
      toast.success(data.message);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <div className="p-6"><Link to="/"><Logo /></Link></div>
      <div className="flex-1 flex items-center justify-center px-4 py-12">
        <div className="w-full max-w-md p-8 bg-[#F9FAFB] border border-gray-200 rounded-2xl">
          <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-[#F26A21] font-semibold">
            <UserPlus className="w-4 h-4" /> Nueva cuenta alumno
          </div>
          <h1 className="mt-2 text-2xl font-bold text-[#0B0B0B] font-display">Crea tu cuenta</h1>
          <p className="mt-2 text-sm text-gray-600">
            Después de crear tu cuenta, tu institución partner activará tu beneficio.
          </p>

          {done ? (
            <div className="mt-8 p-4 rounded-md bg-emerald-500/10 border border-emerald-500/40 text-emerald-200 text-sm">
              <p className="font-semibold">Cuenta creada exitosamente.</p>
              <p className="mt-1 text-emerald-300">Contacta a tu institución partner para activar tu beneficio.</p>
              <button onClick={() => nav("/login")} className="mt-4 text-[#0B0B0B] underline">Ir a login →</button>
            </div>
          ) : (
            <form onSubmit={submit} className="mt-8 space-y-4" data-testid="register-form">
              <div>
                <label className="text-[11px] font-semibold uppercase tracking-widest text-gray-600">Nombre completo *</label>
                <input data-testid="register-name" required value={form.full_name} onChange={(e) => setForm({ ...form, full_name: e.target.value })}
                  className="w-full mt-1 bg-white border border-gray-200 rounded-md px-3 py-2 text-sm text-[#0B0B0B] focus:outline-none focus:border-[#F26A21]" />
              </div>
              <div>
                <label className="text-[11px] font-semibold uppercase tracking-widest text-gray-600">Correo *</label>
                <input data-testid="register-email" required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
                  className="w-full mt-1 bg-white border border-gray-200 rounded-md px-3 py-2 text-sm text-[#0B0B0B] focus:outline-none focus:border-[#F26A21]" />
              </div>
              <div>
                <label className="text-[11px] font-semibold uppercase tracking-widest text-gray-600">Contraseña (mín. 8) *</label>
                <input data-testid="register-password" required type="password" minLength={8} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
                  className="w-full mt-1 bg-white border border-gray-200 rounded-md px-3 py-2 text-sm text-[#0B0B0B] focus:outline-none focus:border-[#F26A21]" />
              </div>
              <button type="submit" disabled={submitting} data-testid="register-submit-btn" className="w-full py-3 rounded-md bg-[#F26A21] hover:bg-[#D9541A] text-[#0B0B0B] font-semibold disabled:opacity-60 transition-all">
                {submitting ? "Creando..." : "Crear cuenta"}
              </button>
            </form>
          )}
          <p className="mt-6 text-center text-sm text-gray-600">
            ¿Ya tienes cuenta? <Link to="/login" className="text-[#F26A21] hover:text-[#0B0B0B]">Ingresar</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
